'use client';

import { c as _c } from "react/compiler-runtime";
import { PaymentMethods } from 'api-graphql-types/enums';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import StripeNativePaymentButton from './StripeNativePaymentButton';
import styles from './SubmitButton.module.css';
import DonationAmountSum from '@/donationPages/_dependencies/components/DonationAmountSum';
import PaypalButton from '@/donationPages/_dependencies/components/formParts/SubmitButton/PaypalButton';
import { useDonationFormConfig, useDonationFormContext, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
import FormSubmitButton from '@/form/FormSubmitButton';
import type { ReactNode } from 'react';
function ButtonContainer(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className={styles.buttonContainer}>{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function SubmitButton(t0) {
  const $ = _c(29);
  const {
    className: className_
  } = t0;
  const {
    paypalClientId
  } = useDonationFormConfig();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["payment_method"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [paymentMethod] = useDonationFormValues(t1);
  const {
    formState
  } = useDonationFormContext();
  const {
    isSubmitting
  } = formState;
  const t = useTranslations();
  let t2;
  if ($[1] !== className_) {
    t2 = classNames(styles.button, className_);
    $[1] = className_;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const className = t2;
  let t3;
  if ($[3] !== isSubmitting) {
    t3 = e => {
      if (isSubmitting) {
        e.preventDefault();
      }
    };
    $[3] = isSubmitting;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onClick = t3;
  switch (paymentMethod) {
    case PaymentMethods.Paypal:
      {
        let t4;
        if ($[5] !== paypalClientId) {
          t4 = <ButtonContainer><PaypalButton clientId={paypalClientId} key={paypalClientId} /></ButtonContainer>;
          $[5] = paypalClientId;
          $[6] = t4;
        } else {
          t4 = $[6];
        }
        return t4;
      }
    case PaymentMethods.StripeApplePay:
    case PaymentMethods.StripeGooglePay:
      {
        let t4;
        if ($[7] !== paymentMethod) {
          t4 = <StripeNativePaymentButton paymentMethod={paymentMethod} />;
          $[7] = paymentMethod;
          $[8] = t4;
        } else {
          t4 = $[8];
        }
        return t4;
      }
    case PaymentMethods.DirectDeposit:
      {
        let t4;
        if ($[9] !== t) {
          t4 = t("nextjs.donate.submit_button.direct_deposit");
          $[9] = t;
          $[10] = t4;
        } else {
          t4 = $[10];
        }
        let t5;
        if ($[11] !== className || $[12] !== onClick || $[13] !== t4) {
          t5 = <ButtonContainer><FormSubmitButton className={className} onClick={onClick} data-testid="donate-form-donate-button">{t4}</FormSubmitButton></ButtonContainer>;
          $[11] = className;
          $[12] = onClick;
          $[13] = t4;
          $[14] = t5;
        } else {
          t5 = $[14];
        }
        return t5;
      }
    default:
      {
        let t4;
        if ($[15] !== t) {
          t4 = t("nextjs.donate.submit_button.default.before_amount");
          $[15] = t;
          $[16] = t4;
        } else {
          t4 = $[16];
        }
        let t5;
        if ($[17] !== t4) {
          t5 = <span>{t4}</span>;
          $[17] = t4;
          $[18] = t5;
        } else {
          t5 = $[18];
        }
        let t6;
        if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <DonationAmountSum fields={["amount_cents", "codonation_cents"]} />;
          $[19] = t6;
        } else {
          t6 = $[19];
        }
        let t7;
        if ($[20] !== t) {
          t7 = t("nextjs.donate.submit_button.default.after_amount");
          $[20] = t;
          $[21] = t7;
        } else {
          t7 = $[21];
        }
        let t8;
        if ($[22] !== t7) {
          t8 = <span>{t7}</span>;
          $[22] = t7;
          $[23] = t8;
        } else {
          t8 = $[23];
        }
        let t9;
        if ($[24] !== className || $[25] !== onClick || $[26] !== t5 || $[27] !== t8) {
          t9 = <><ButtonContainer><FormSubmitButton className={className} onClick={onClick} data-testid="donate-form-donate-button">{t5}{t6}{t8}</FormSubmitButton></ButtonContainer></>;
          $[24] = className;
          $[25] = onClick;
          $[26] = t5;
          $[27] = t8;
          $[28] = t9;
        } else {
          t9 = $[28];
        }
        return t9;
      }
  }
}
export default SubmitButton;